import React, { useState } from 'react';
import './RejectReasonModal.css';

/**
 * Reject Reason Modal Component
 * Asks for reason when rejecting content or submission
 */
function RejectReasonModal({ item, roleColor, onSubmit, onClose, type = 'content' }) {
  const [reason, setReason] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async () => {
    if (!reason.trim()) {
      alert('Harap masukkan alasan penolakan');
      return;
    }

    setSubmitting(true);
    try {
      await onSubmit(reason);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-dialog" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header reject-header" style={{ borderBottomColor: '#ef4444' }}>
          <h3>Tolak {type === 'content' ? 'Konten' : 'Pengajuan'}</h3>
          <button className="modal-close" onClick={onClose}>×</button>
        </div>

        <div className="modal-body">
          <div className="rejection-info reject">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <line x1="18" y1="6" x2="6" y2="18" />
              <line x1="6" y1="6" x2="18" y2="18" />
            </svg>
            <p>Anda akan menolak {type === 'content' ? 'konten' : 'pengajuan'} berikut:</p>
            <h4>{item?.title || item?.name}</h4>
          </div>

          <div className="form-group">
            <label htmlFor="reason">Alasan Penolakan <span className="required">*</span>:</label>
            <textarea
              id="reason"
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              placeholder="Jelaskan mengapa Anda menolak. Ini akan dibagikan kepada pengajuan."
              rows="5"
              required
            />
            <small>Alasan penolakan adalah wajib dan akan dikirimkan kepada pengajuan</small>
          </div>
        </div>

        <div className="modal-footer">
          <button 
            className="btn btn-secondary"
            onClick={onClose}
            disabled={submitting}
          >
            Batal
          </button>
          <button 
            className="btn btn-reject"
            onClick={handleSubmit}
            disabled={submitting}
          >
            {submitting ? 'Memproses...' : 'Tolak'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default RejectReasonModal;
